import ErasmusuLogo from './ErasmusuLogo';

export default ErasmusuLogo;
